<template>
<div class="content">
<!--  扫码进入-->
</div>
</template>

<script>
import { exchangeGoods } from '@/api/shoper'
export default {
  name: "order",
  data(){
    return {
      shopOrderId: '',
      orderCode:''
    }
  },
  created() {
    let order_id = this.$route.params.id
    console.log(order_id)
    let code = this.$route.params.code
    console.log(code)
    this.submitGoods(order_id,code)

  },
  methods: {
    submitGoods(id,code){
      const data = {
        code: code
      }
      exchangeGoods(id,data).then(res => {
        if(res.code == 200)
        {
          // this.$toast(res.message)
          this.$dialog.alert({
            title: '标题',
            message: res.message,
            confirmButtonText:'知道了',
            close
          });
        }else {
          this.$dialog.alert({
            title: '标题',
            message: res.message,
            confirmButtonText:'知道了',
            close
          });
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
